<div class="card card-content" fxFlexFill>
    <div class="card-img d-flex align-items-center justify-content-center">
        <ng-container *ngIf="item.bgImageUrl; else elseTemplate">
            <img [src]="item.bgImageUrl | safe: 'url'" alt="news image" class="img-fluid" fxFlexFill/>
        </ng-container>
        <ng-template #elseTemplate>
            <img src="/assets/images/background_img.jpg" alt="news image" class="img-fluid" fxFlexFill/>
        </ng-template>
    </div>
    <div class="card-body" fxLayout="column" fxLayoutAlign="start stretch" [routerLink]="['/home/news/', item.contentId]">
        <div class="card-text d-flex justify-content-between mb-2">
            <div class="card-date small text-secondary pre-headline">{{ item.updatedOn || item.creationDate | date : 'yyyy-MM-dd' }}</div>
        </div>
        <h6 class="">
            {{ item.title }}
        </h6>
        <div fxFlex>
            <p class="card-text text-content" [innerHTML]="item.content | firstParagraph : 1 | safe : 'html'"></p>
        </div>
        <a fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center" class="card-link read-more pt-2" routerLink="/home/news/{{ item.contentId }}">
            <mat-icon>trending_flat</mat-icon>
            <span> Read more</span>
        </a>
    </div>
</div>
